// // src/components/LoginForm.jsx
// import { useState } from "react";
// import { auth, provider } from "../firebase";
// import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
// import { FcGoogle } from "react-icons/fc";

// export default function LoginForm({ onSwitch, onClose }) {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState(null);

//   const handleEmailLogin = async (e) => {
//     e.preventDefault();
//     setError(null);
//     try {
//       await signInWithEmailAndPassword(auth, email, password);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   const handleGoogleLogin = async () => {
//     try {
//       await signInWithPopup(auth, provider);
//       // console.log("Logged in as:", auth.currentUser);
//       onClose(); // ✅ Close modal
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   return (
//     <form onSubmit={handleEmailLogin} className="space-y-4">
//       {error && <p className="text-red-500 text-sm">{error}</p>}
//       <div className="flex justify-between items-center mb-6">
//         <h3 className="text-xl font-semibold">Sign In</h3>
//       </div>
//       <input
//         type="email"
//         placeholder="Email / Phone Number"
//         value={email}
//         onChange={(e) => setEmail(e.target.value)}
//         required
//         className="w-full px-4 py-2 bg-slate-800 text-white rounded-md"
//       />
//       <input
//         type="password"
//         placeholder="Password"
//         value={password}
//         onChange={(e) => setPassword(e.target.value)}
//         required
//         className="w-full px-4 py-2 bg-slate-800 text-white rounded-md"
//       />

//       <button
//         type="submit"
//         className="w-full bg-green-400 hover:bg-green-500 text-black font-semibold py-2 rounded-md"
//       >
//         Sign In
//       </button>

//       <p className="text-sm text-center text-gray-400">
//         Don&apos;t have an account?{" "}
//         <span
//           onClick={onSwitch}
//           className="text-green-500 hover:underline cursor-pointer"
//         >
//           Sign Up
//         </span>
//       </p>

//       <div className="flex items-center justify-center gap-4 mt-4">
//         <button
//           onClick={handleGoogleLogin}
//           type="button"
//           className="bg-slate-700 p-3 rounded-full hover:bg-slate-600"
//         >
//           <FcGoogle size={24} />
//         </button>
//       </div>
//     </form>
//   );
// }

// src/components/LoginForm.jsx
import { useState } from "react";
import { auth, provider } from "../firebase";
import { signInWithEmailAndPassword, signInWithPopup } from "firebase/auth";
import { FcGoogle } from "react-icons/fc";

export default function LoginForm({ onSwitch, onClose }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loadingEmail, setLoadingEmail] = useState(false);
  const [loadingGoogle, setLoadingGoogle] = useState(false);

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setLoadingEmail(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // IMPORTANT: do not navigate here — let the modal/app handle redirect
      onClose?.();
    } catch (err) {
      setError(err?.message || "Sign in failed");
    } finally {
      setLoadingEmail(false);
    }
  };

  const handleGoogleLogin = async () => {
    setError(null);
    setLoadingGoogle(true);
    try {
      await signInWithPopup(auth, provider);
      // IMPORTANT: do not navigate here — let the modal/app handle redirect
      onClose?.();
    } catch (err) {
      setError(err?.message || "Google sign in failed");
    } finally {
      setLoadingGoogle(false);
    }
  };

  return (
    <form onSubmit={handleEmailLogin} className="space-y-4">
      {error && <p className="text-red-500 text-sm">{error}</p>}

      <div className="flex justify-between items-center mb-6">
        <h3 className="text-xl font-semibold">Sign In</h3>
      </div>

      <input
        type="email"
        placeholder="Email"
        autoComplete="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="w-full px-4 py-2 bg-slate-800 text-white rounded-md"
        disabled={loadingEmail || loadingGoogle}
      />

      <input
        type="password"
        placeholder="Password"
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        className="w-full px-4 py-2 bg-slate-800 text-white rounded-md"
        disabled={loadingEmail || loadingGoogle}
      />

      <button
        type="submit"
        disabled={loadingEmail || loadingGoogle}
        className="w-full bg-green-400 hover:bg-green-500 text-black font-semibold py-2 rounded-md disabled:opacity-60"
      >
        {loadingEmail ? "Signing in…" : "Sign In"}
      </button>

      <p className="text-sm text-center text-gray-400">
        Don&apos;t have an account?{" "}
        <span
          onClick={onSwitch}
          className="text-green-500 hover:underline cursor-pointer"
        >
          Sign Up
        </span>
      </p>

      <div className="flex items-center justify-center gap-4 mt-4">
        <button
          onClick={handleGoogleLogin}
          type="button"
          disabled={loadingGoogle || loadingEmail}
          className="bg-slate-700 p-3 rounded-full hover:bg-slate-600 disabled:opacity-60"
          title="Continue with Google"
        >
          {loadingGoogle ? (
            <span className="text-sm px-1">…</span>
          ) : (
            <FcGoogle size={24} />
          )}
        </button>
      </div>
    </form>
  );
}
